module.exports = __webpack_public_path__ + "media/images/how-img-320-2eceb5b5ac1ab44f5b063b3864c763e6.svg";